/* YG — Shop mega menu behaviour.
   Trigger: click always toggles; hover (desktop only, when open_on="hover") also opens/closes.
   Tabs: hover activates on desktop; click activates at any width.
   Close: Esc, outside click, or (deliberate improvement over the reference) a real focus trap —
   the reference just closes on tab-out past the last link; here Tab/Shift+Tab wrap inside the
   panel instead, per this project's own accessibility requirement. Body scroll locks on desktop
   only, matching the reference. Respects prefers-reduced-motion by skipping the close delay. */
(function () {
  'use strict';

  function initShopMenu(root) {
    var panel = (root || document).querySelector('[data-yg-shop-panel]');
    var overlay = (root || document).querySelector('[data-yg-shop-overlay]');
    var trigger = document.querySelector('[data-yg-shop-trigger]');
    if (!panel || !trigger || panel.__ygShopInit) return;
    panel.__ygShopInit = true;

    var openOn = panel.getAttribute('data-open-on') || 'click';
    var tablist = panel.querySelector('[data-yg-shop-tablist]');
    var content = panel.querySelector('[data-yg-shop-content]');
    var tabs = Array.prototype.slice.call(panel.querySelectorAll('[data-yg-shop-tab]'));
    var panels = Array.prototype.slice.call(panel.querySelectorAll('[data-yg-shop-tabpanel]'));
    var isOpen = false;

    function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }
    function reduceMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function positionBelowHeader() {
      var header = document.querySelector('.yg-lw-hd');
      var scope = panel.closest('.yg-shop-menu-scope') || panel.parentElement;
      var top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
      if (scope) scope.style.setProperty('--yg-shop-top', top + 'px');
    }

    function selectTab(index) {
      if (index < 0 || index >= tabs.length) return;
      tabs.forEach(function (t, i) {
        var active = i === index;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (p, i) { p.hidden = i !== index; });
      if (content) content.classList.add('has-active-tab');
    }

    function clearActiveTab() {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); t.setAttribute('tabindex', '-1'); });
      panels.forEach(function (p) { p.hidden = true; });
      if (content) content.classList.remove('has-active-tab');
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      positionBelowHeader();
      panel.hidden = false;
      if (overlay) overlay.hidden = false;
      void panel.offsetHeight;
      panel.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      selectTab(0);
      if (isDesktop()) document.documentElement.classList.add('yg-shop-menu-open');
      document.addEventListener('keydown', onKeydown);
      document.addEventListener('click', onOutsideClick, true);
    }

    function close(opts) {
      opts = opts || {};
      if (!isOpen) return;
      isOpen = false;
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('yg-shop-menu-open');
      document.removeEventListener('keydown', onKeydown);
      document.removeEventListener('click', onOutsideClick, true);
      var duration = reduceMotion() ? 0 : 200;
      setTimeout(function () {
        if (!isOpen) {
          panel.hidden = true;
          if (overlay) overlay.hidden = true;
          clearActiveTab();
        }
      }, duration);
      if (!opts.skipFocus) trigger.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var focusable = Array.prototype.slice.call(
          panel.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])')
        ).filter(function (el) { return el.offsetParent !== null; });
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    function onOutsideClick(e) {
      var navRow = trigger.closest('.yg-lw-hd__nav') || trigger.parentElement;
      if (panel.contains(e.target) || (navRow && navRow.contains(e.target))) return;
      close({ skipFocus: true });
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (isOpen) close(); else open();
    });

    if (openOn === 'hover') {
      var hoverCloseTimer = null;
      var hoverCloseDelay = 200;
      function cancelHoverClose() {
        if (hoverCloseTimer) { clearTimeout(hoverCloseTimer); hoverCloseTimer = null; }
      }
      function scheduleHoverClose() {
        cancelHoverClose();
        hoverCloseTimer = setTimeout(function () { close({ skipFocus: true }); }, hoverCloseDelay);
      }
      trigger.addEventListener('mouseenter', function () { if (isDesktop()) { cancelHoverClose(); open(); } });
      trigger.addEventListener('mouseleave', function () { if (isDesktop()) scheduleHoverClose(); });
      panel.addEventListener('mouseenter', function () { if (isDesktop()) cancelHoverClose(); });
      panel.addEventListener('mouseleave', function () { if (isDesktop()) scheduleHoverClose(); });
      trigger.addEventListener('focus', function () { if (isDesktop()) { cancelHoverClose(); open(); } });
    }

    window.addEventListener('resize', function () { if (isOpen) positionBelowHeader(); });
    window.addEventListener('scroll', function () { if (isOpen) positionBelowHeader(); }, { passive: true });

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { selectTab(i); });
      tab.addEventListener('mouseenter', function () { if (isDesktop()) selectTab(i); });
    });

    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var currentIndex = tabs.indexOf(document.activeElement);
        if (currentIndex === -1) return;
        var moves = {
          ArrowUp: function () { return (currentIndex - 1 + tabs.length) % tabs.length; },
          ArrowDown: function () { return (currentIndex + 1) % tabs.length; },
          Home: function () { return 0; },
          End: function () { return tabs.length - 1; }
        };
        if (moves[e.key]) {
          e.preventDefault();
          var next = moves[e.key]();
          selectTab(next);
          tabs[next].focus();
        }
      });
    }
  }

  function init(root) { initShopMenu(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
